// "VCYY" followed by 12 digits, e.g. VCYY004821960733. Anything else — missing
// entirely on accounts predating member IDs, or the old 'VCYY-XXXXXXXX' shape
// the admin toggle used to mint — gets reissued by the ensureMemberId callable.
// Kept in sync by hand with MEMBER_ID_PATTERN in functions/index.js, which is
// the copy that actually decides what gets written.
export const MEMBER_ID_PATTERN = /^VCYY\d{12}$/;

// Volcyy Black is the paid tier. A member keeps Black access while their
// subscription is active, and a cancelled member retains it until their paid
// period actually ends (membershipExpiry is still in the future). Every
// signed-up account is at minimum on Volcyy (free) — no payment required.
//
// A member whose renewal was declined ('past_due') also keeps Black while
// Stripe is still trying to collect. That window is Stripe's to close, not
// ours: it is configured in the Stripe dashboard, and when it ends Stripe
// cancels the subscription and the webhook writes the terminal status here.
// No date is checked in that branch — membershipExpiry is the end of the
// period they last paid for and has already passed, which is exactly why the
// renewal is being attempted.
//
// Lives outside AuthContext so callers holding a profile that hasn't reached
// React state yet (the post-payment poll in CheckoutPage) can ask the same
// question the context's isBlack answers. Mirrors hasBlackEntitlement in
// functions/index.js, which is the enforcing copy — this one only drives UI.
export function profileIsBlack(profile) {
  if (profile?.membershipTier !== 'black') return false;
  const status = profile?.membershipStatus;
  if (status === 'active' || status === 'cancelling') {
    return profile?.membershipExpiry?.toDate?.() > new Date();
  }
  return status === 'past_due';
}

// True while a renewal has been declined and Stripe is still trying to collect.
// Drives the "update your card" banner — deliberately independent of
// profileIsBlack, because the point of the retry window is that both are true
// at once: the member still has their benefits AND needs to act.
export function profileNeedsPaymentUpdate(profile) {
  return profile?.membershipStatus === 'past_due';
}
